import React, { createContext, useMemo } from 'react';
import { useSearchInfiniteState } from './useInfiniteSearchState';
import { useSearchState } from './useSearchState';
export const Context = createContext(undefined);
export const Provider = ({ children, itemsPerPage, onChange, ...rest }) => {
    const { state, ...searchActions } = useSearchState(rest, onChange);
    const { pages, ...infiniteActions } = useSearchInfiniteState(state.page);
    const value = useMemo(() => ({
        state,
        ...searchActions,
        pages,
        ...infiniteActions,
        itemsPerPage,
    }), [infiniteActions, itemsPerPage, pages, searchActions, state]);
    return React.createElement(Context.Provider, { value: value }, children);
};
//# sourceMappingURL=Provider.js.map